'use client'

import { useBrandAuth } from '@/_hooks/useBrandAuth'

interface BrandAuthProviderProps {
  children: React.ReactNode
}

/**
 * Client component wrapper that initializes brand authentication
 * This sets up the active brand in the store and fetches brand-specific tokens
 */
export default function BrandAuthProvider({ children }: BrandAuthProviderProps) {
  // Initialize brand authentication
  useBrandAuth()
  
  return <>{children}</>
}
